import { Card, CardBody } from "reactstrap";
import Loader from "react-loaders";

import { UrenoverzichtProvider, useUrenoverzichtContext } from "./context/UrenoverzichtContext";

import PeriodOverview from "./PeriodOverview";
import MonthlyOverview from "./MonthlyOverview";
import WeeklyOverview from "./WeeklyOverview";
import Footer from "./Footer";


const Urenoverzicht = ({ children }) => {
	return (
		<UrenoverzichtProvider>
			<div className="urenoverzicht">{children}</div>
		</UrenoverzichtProvider>
	);
};

const UrenoverzichtWrapper = ({ children }) => {
	const { loading } = useUrenoverzichtContext();
	return (
		<>
			{loading ? (
				<Card className="main-card">
					<CardBody className="d-flex flex-column">
						<Loader
							type="ball-grid-pulse"
							className={"mt-3 d-flex mx-auto justify-content-center"}
						/>
					</CardBody>
				</Card>
			) : (
				<div className="row">{children}</div>
			)}
		</>
	);
};

Urenoverzicht.PeriodOverview = () => {
	return (
		<div className="col-12">
			<PeriodOverview />
		</div>
	);
};

Urenoverzicht.MonthlyOverview = () => {
	return (
		<div className="col-12">
			<MonthlyOverview />
		</div>
	);
};

Urenoverzicht.WeeklyOverview = () => {
	return <WeeklyOverview />;
};

Urenoverzicht.Wrapper = ({ children }) => {
	return <UrenoverzichtWrapper>{children}</UrenoverzichtWrapper>;
};

Urenoverzicht.Footer = () => {
	return <Footer />;
};

export default Urenoverzicht;
